import {
  Bestellung,
  LoadState,
  RemoteResult,
  ServiceAnfordernRequest,
} from "mangdto"
import router from "@/router"
import Poster from "@/util/poster"
import RestPaths from "@/util/rest_paths"
import BaseLogic from "../base_logic"

export default class ServiceAnfordernLogic extends BaseLogic {
  bestellung?: Bestellung = null
  kommentare?: string = null
  rechnungAnfordern: boolean = false

  anfordernLoadState: LoadState = LoadState.Idle

  init() {
    this.bestellung = this.mainLogic.bestellung
  }

  absenden() {
    this.anfordernLoadState = LoadState.Loading

    var request = new ServiceAnfordernRequest()
    request.bestellungId = this.bestellung.id
    request.kommentare = this.kommentare
    request.rechnungAnfordern = this.rechnungAnfordern

    Poster.postUser<RemoteResult<any>>(
      RestPaths.bestellungKundeServiceAnfordern,
      request,
    )
      .then((response) => {
        if (response.data.success) {
          this.anfordernLoadState = LoadState.Completed
          router.go(-1)
        } else {
          this.anfordernLoadState = LoadState.Error
        }
      })
      .catch(() => {
        this.anfordernLoadState = LoadState.Error
      })
  }
}
